import ProjectCostReport from './ProjectCostReport';

const ProjectCostReportMain = () => (
  <div
    style={{
      display: 'flex',
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
      height: '100%',
      flexDirection: 'column',
      position: 'relative',
    }}
  >
    <ProjectCostReport />
  </div>
);

export default ProjectCostReportMain;
